import { useMemo } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";

const AdditionalDocumentsTableData = (tutor) => {
  const columns = [
    { name: "sno", align: "center" },
    { name: "Document Title", align: "left" },
    { name: "Document File", align: "center" },
    { name: "Uploaded At", align: "center" },
  ];

  const rows = useMemo(() => {
    if (!tutor) return [];

    const additionalDocuments = tutor.additionalDocuments || [];

    return additionalDocuments.map((doc, index) => ({
      sno: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      "Document Title": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {doc?.documentTitle || "N/A"}
        </ArgonTypography>
      ),
      "Document File": doc.documentUrl ? (
        <ArgonBadge
          variant="gradient"
          badgeContent="View"
          color="info"
          size="xs"
          container
          component="a"
          href={doc.documentUrl}
          target="_blank"
          rel="noopener noreferrer"
        />
      ) : (
        <ArgonTypography variant="caption" color="text">
          Not Uploaded
        </ArgonTypography>
      ),
      "Uploaded At": (
        <ArgonTypography variant="caption" color="text">
          {doc.uploadedAt
            ? new Date(doc.uploadedAt).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "N/A"}
        </ArgonTypography>
      ),
    }));
  }, [tutor]);

  return { columns, rows };
};

export default AdditionalDocumentsTableData;
